import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import {
  type FieldValues,
  type Path,
  type UseFormSetFocus,
} from "react-hook-form";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 폼 필드에서 엔터키를 눌렀을 때 다음 필드로 포커스를 이동시키는 핸들러를 생성합니다.
 *
 * @example
 * ```tsx
 * <Input
 *   onKeyDown={createFieldNavigationHandler(form.setFocus, "nextField")}
 * />
 * ```
 */
export function createFieldNavigationHandler<T extends FieldValues>(
  setFocus: UseFormSetFocus<T>,
  nextField: Path<T>
) {
  return (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setFocus(nextField);
    }
  };
}
